"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditPetForm = void 0;
var react_1 = __importStar(require("react"));
var index_css_1 = __importDefault(require("./index.css"));
var text_field_1 = require("../../ui/text-field");
var dropzone_1 = require("../dropzone");
var buttons_1 = require("../../ui/buttons");
var map_1 = require("../map");
var link_1 = require("../../ui/link");
var api_1 = require("../../lib/api");
var recoil_1 = require("recoil");
var login_1 = require("../../hooks/login");
var react_router_dom_1 = require("react-router-dom");
function EditPetForm(props) {
    var navigate = (0, react_router_dom_1.useNavigate)();
    var tokenValue = (0, recoil_1.useRecoilValue)(login_1.token);
    var _a = (0, react_1.useState)(undefined), imageUrl = _a[0], setImageUrl = _a[1];
    var _b = (0, react_1.useState)(undefined), locationData = _b[0], setLocationData = _b[1];
    function preventKeyDown(e) {
        if (e.key == "Enter") {
            e.preventDefault();
            return;
        }
    }
    function handleSubmit(e) {
        e.preventDefault();
        var updateData = {
            name: e.target.nombre.value,
        };
        if (imageUrl) {
            updateData.imageUrl = imageUrl;
        }
        if (locationData) {
            updateData.lat = locationData.lat;
            updateData.lng = locationData.lng;
            updateData.city = locationData.city;
            updateData.region = locationData.region;
        }
        (0, api_1.updateMascota)(updateData, props.petData.id, tokenValue).then(function () {
            navigate("/mis-mascotas");
        });
    }
    function deleteMascota() {
        var confirmation = window.confirm("Deseas eliminar esta mascota?");
        if (confirmation) {
            (0, api_1.fetchDeleteMascota)(props.petData.id, tokenValue).then(function () {
                navigate("/mis-mascotas");
            });
        }
        else {
            return;
        }
    }
    function toggleFoundState() {
        var updateData;
        if (props.petData.isFound) {
            updateData = {
                isLost: true,
            };
        }
        else {
            updateData = {
                isFound: true,
            };
        }
        (0, api_1.updateMascota)(updateData, props.petData.id, tokenValue).then(function () {
            navigate("/mis-mascotas");
        });
    }
    return (react_1.default.createElement("form", { onKeyDown: preventKeyDown, onSubmit: handleSubmit, className: index_css_1.default.container },
        react_1.default.createElement(text_field_1.TextField, { autoComplete: "off", label: "NOMBRE", name: "nombre", type: "text", defaultValue: props.petData.name }),
        react_1.default.createElement(dropzone_1.DropzoneForm, { defaultImgUrl: props.petData.imageUrl, cb: setImageUrl }),
        react_1.default.createElement(map_1.Map, { cb: setLocationData, defaultCoords: [props.petData.lng, props.petData.lat] }),
        react_1.default.createElement(buttons_1.MainButton, { type: "submit", color: "pink" }, "Guardar"),
        props.petData.isFound ? (react_1.default.createElement(LostButton, { onClick: toggleFoundState })) : (react_1.default.createElement(FoundButton, { onClick: toggleFoundState })),
        react_1.default.createElement(link_1.LinkButton, { onClick: deleteMascota }, "DESPUBLICAR")));
}
exports.EditPetForm = EditPetForm;
function FoundButton(props) {
    return (react_1.default.createElement(buttons_1.MainButton, { onClick: props.onClick, type: "button", color: "green" }, "Reportar como encontrado"));
}
function LostButton(props) {
    return (react_1.default.createElement(buttons_1.MainButton, { onClick: props.onClick, type: "button", color: "green" }, "Reportar como perdido"));
}
